<template>
  <v-app-bar class="app-bar" color="primary" app="app" clipped-left="clipped-left" dark="dark" extension-height="64">
    <v-app-bar-nav-icon @click.stop="clickBar"></v-app-bar-nav-icon>
    <v-toolbar-title><img class="logo" src="/logo.png"/></v-toolbar-title>
    <toolbar :config="toolbarConfig" slot="extension" v-if="toolbarConfig"></toolbar>
  </v-app-bar>
</template>

<script>
import { fetchConfig } from '@/libs/configs/toolbar.js'
import Toolbar from './Toolbar'

export default {
  components: { Toolbar },
  computed: {
    toolbarConfig () {
      return fetchConfig(this.$route)
    }
  },
  methods: {
    clickBar () {
      this.$emit('clickBar')
    }
  }
}
</script>

<style lang="stylus" scoped>
  .logo
    width auto
    height 20px

  .app-bar
    &/deep/ .v-toolbar__extension
      background-color $secondary
</style>
